import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"

export default function useTableColumnsTicketPendientesAsignacion() {
  const columnsTicketPendientes = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "numero_ticket",
        header: "N° Ticket",

      },
      {
        accessorKey: 'operador_genera_ticket',
        header: 'Operador Genera Ticket',
        size:250
      },
      {
        accessorKey: 'departamento_genera',
        header: "Departamento Genera"
      },
      {
        accessorKey: 'operador_asignado',
        header: 'Operador Asignado'
      },
      {
        accessorKey: 'informacion_ticket',
        header: 'Información Ticket'
      },
      {
        accessorKey: 'utltima_visita',
        header: 'Última Visita'
      },
      {
        accessorKey: 'tipo_servicio',
        header: 'Tipo de Servicio'
      },
      {
        accessorKey: 'nombre_cliente',
        header: 'Nombre Cliente'
      },
      {
        accessorKey: 'categoria',
        header: 'Categoría'
      },
      {
        accessorKey: 'observaciones',
        header: 'Observaciones'
      },
      {
        accessorKey: 'ciudad',
        header: 'Ciudad'
      },
      {
        accessorKey: 'sector',
        header: 'Sector'
      },
      {
        accessorKey: 'direccion',
        header: 'Dirección'
      },
      {
        accessorKey: 'coordenadas',
        header: 'Coordenadas'
      },
      {
        accessorKey: 'hora_asignacion',
        header: 'Hora Asignación'
      },
      {
        accessorKey: 'ultimo_estado_proceso',
        header: 'Último Estado Proceso',
        size:250
      }
    ], []
  )
  return {
    columnsTicketPendientes

  }
}
